import { Component, computed, input, Signal } from '@angular/core';
import { AssetImageConfiguration } from '@features/lazy-image/components/lazy-asset-lazy/lazy-asset-lazy.component';
import { LazyAssetComponent } from '@features/lazy-image/components/lazy-asset/lazy-asset.component';
import { Person } from '@generated/graphql';

@Component({
    selector: 'app-knowledge-article-author',
    imports: [LazyAssetComponent],
    templateUrl: './knowledge-article-author.component.html',
    styles: ``,
})
export class KnowledgeArticleAuthorComponent {
    author = input<Person>();
    imageConfiguration: Signal<AssetImageConfiguration> = computed(() => {
        return {
            image: this.author().image,
            ratioWidth: 1,
            ratioHeight: 1,
            width: 100,
        };
    });
}
